// 학생-----------------------------------------
// 훈련 소개
import TrainingIntroPage from '@/views/common/intro/TrainingIntroPage'
import TrainingIntro from '@/views/common/intro/TrainingIntro'
import TrainingStructure from '@/views/common/intro/TrainingStructure'
import TrainingPlan from '@/views/common/intro/TrainingPlan'

import StudentTestPage from '@/views/student/3.test/StudentTestPage'
import StudentTestSummaryPage from '@/views/student/3.test/StudentTestSummaryPage'

import StudentPrediag from '@/views/student/3.test/pre/StudentPrediagTest'
import StudentPreTest from '@/views/student/3.test/pre/StudentPreTest'
// 자가진단.
import StudentSelfTest from '@/views/student/3.test/self/StudentSelfTest'
import StudentSelfTestExam from '@/views/student/3.test/self/StudentSelfTestExam'
import StudentSelfTestView from '@/views/student/3.test/self/StudentSelfTestView'
// 필답평가
import StudentWritingTest from '@/views/student/3.test/writing/StudentWritingTest'
import StudentWritingTestView from '@/views/student/3.test/writing/StudentWritingTestView'
import StudentWritingTestExam from '@/views/student/3.test/writing/StudentWritingTestExam'

// 수행 자가 평가
import StudentPerformSelfTestView from '@/views/student/3.test/performself/StudentPerformSelfTestView'
import StudentPerformSelfTestExam from '@/views/student/3.test/performself/StudentPerformSelfTestExam'

// 수행평가
import StudentPerformTest from '@/views/student/3.test/perform/StudentPerformTest'
import StudentPerformTestExam from '@/views/student/3.test/perform/StudentPerformTestExam'
import StudentPerformTestView from '@/views/student/3.test/perform/StudentPerformTestView'

// 태도평가
import StudentAttitudeTestView from '@/views/student/3.test/attitude/StudentAttitudeTestView'

// 포트폴리오
import StudentPortfolioTest from '@/views/student/3.test/portfolio/StudentPortfolioTest'
import StudentPortfolioTestExam from '@/views/student/3.test/portfolio/StudentPortfolioTestExam'
import StudentPortfolioTestView from '@/views/student/3.test/portfolio/StudentPortfolioTestView'

// import StudentBoardPage from '@/views/student/4.board/StudentBoardPage'
import StudentBoardPage from '@/views/common/board/Board'

const routes = [
  // 학생
  {
    path: '/student/training',
    name: 'TrainingIntroPage',
    component: TrainingIntroPage,
    children: [
      { path: 'intro', name: 'TrainingIntro', component: TrainingIntro },
      { path: 'structure', name: 'TrainingStructure', component: TrainingStructure },
      { path: 'plan', name: 'TrainingPlan', component: TrainingPlan }
    ]
  },
  {
    path: '/student/test',
    name: 'StudentTestPage',
    component: StudentTestPage,
    children: [
      { path: 'prediag', name: 'StudentPrediag', component: StudentPrediag },
      { path: 'pretest', name: 'StudentPreTest', component: StudentPreTest },
      { path: 'summary', name: 'StudentTestSummaryPage', component: StudentTestSummaryPage },

      { path: 'selftest', name: 'StudentSelfTest', component: StudentSelfTest },
      { path: 'selftest/view', name: 'StudentSelfTestView', component: StudentSelfTestView },
      { path: 'selftest/exam', name: 'StudentSelfTestExam', component: StudentSelfTestExam },

      { path: 'performself/view', name: 'StudentPerformSelfTestView', component: StudentPerformSelfTestView },
      { path: 'performself/exam', name: 'StudentPerformSelfTestExam', component: StudentPerformSelfTestExam },

      { path: 'perform', name: 'StudentPerformTest', component: StudentPerformTest },
      { path: 'perform/view', name: 'StudentPerformTestView', component: StudentPerformTestView },
      { path: 'perform/exam', name: 'StudentPerformTestExam', component: StudentPerformTestExam },

      { path: 'writingtest', name: 'StudentWritingTest', component: StudentWritingTest },
      { path: 'writingtest/view', name: 'StudentWritingTestView', component: StudentWritingTestView },
      { path: 'writingtest/exam', name: 'StudentWritingTestExam', component: StudentWritingTestExam },

      { path: 'attitude/view', name: 'StudentAttitudeTestView', component: StudentAttitudeTestView },

      { path: 'portfolio', name: 'StudentPortfolioTest', component: StudentPortfolioTest },
      { path: 'portfolio/view', name: 'StudentPortfolioTestView', component: StudentPortfolioTestView },
      { path: 'portfolio/exam', name: 'StudentPortfolioTestExam', component: StudentPortfolioTestExam }
    ]
  },
  { path: '/student/board', name: 'StudentBoardPage', component: StudentBoardPage }
]

export default routes
